import React from "react";
import { ChartItem } from "src/types/customTooltipType";
import dayjs from "dayjs";
import { Box, styled, Typography } from "@mui/material";
import { TypeC1Watts } from "../../../types/dashboardTypes";
import {
  DECIMAL_PLACES,
  MILLISECONDS_TO_SECONDS,
  TIME_FORMAT,
} from "../../../system/constants";

const CustomTooltip: React.FC<ChartItem> = ({ payload }) => {
  if (!payload) {
    return null;
  }

  const timeTooltip = dayjs(
    payload?.[0]?.payload?.timestamp * MILLISECONDS_TO_SECONDS
  ).format(TIME_FORMAT);

  const watts_usb_1 = (payload?.[0]?.payload?.usb_1_watts ?? 0).toFixed(
    DECIMAL_PLACES
  );
  const car_watts = (payload?.[0]?.payload?.car_watts ?? 0).toFixed(
    DECIMAL_PLACES
  );
  const type_c_1_watts = (
    (payload?.[0]?.payload as TypeC1Watts)?.type_c_1_watts ?? 0
  ).toFixed(DECIMAL_PLACES);

  return (
    <CustomTooltipWrap className="custom-tooltip">
      <Typography className="time-tooltip">{timeTooltip}</Typography>
      <Typography className="param param-1">
        <span className="usb_1_watts"></span>
        {watts_usb_1} W
      </Typography>
      <Typography className="param param-1">
        <span className="usb_2_watts"></span>
        {car_watts} W
      </Typography>
      <Typography className="param param-1">
        <span className="type_c_1_watts"></span>
        {type_c_1_watts} W
      </Typography>
    </CustomTooltipWrap>
  );
};

const CustomTooltipWrap = styled(Box)({
  fontSize: "12px",
  fontWeight: "500",
  "& .param": {
    fontSize: "10px",
    fontWeight: "400",
    display: "flex",
    span: {
      width: "10px",
      height: "10px",
      top: "3px",
    },
  },
});

export default CustomTooltip;
